// extracted by mini-css-extract-plugin
export default {"react-pr-files-file-tree":"PullRequestFileTree-module__react-pr-files-file-tree--VMGJS"};